import { useWatch } from '@vtex/admin-ui-form'
import { useDrawerState, useFormStateContext } from 'ui'
import { EMPTY_PROGRESSIVE_DISCOUNT_PROMOTION } from '../../../../../constants'
import { type ProgressiveDiscountEffect } from '../../../../../typings'
import { EditorProgressiveDiscount } from '../Editor'
import { ViewBenefit } from './Benefit'
import { Empty } from './Empty'
import { ViewTrigger } from './Trigger'

type Props = {
  name: string
}

export function ViewProgressiveDiscount(props: Props) {
  const { name } = props

  const { form } = useFormStateContext()

  const config: ProgressiveDiscountEffect = useWatch({ form, name })

  const editorState = useDrawerState()

  const isFilled = config.trigger || config.benefit

  const handleRemove = () =>
    form.setValue(name, EMPTY_PROGRESSIVE_DISCOUNT_PROMOTION.progressive)

  const handleEdit = () => editorState.show()

  const handleSave = (config: ProgressiveDiscountEffect) =>
    form.setValue(name, config)

  return (
    <>
      {isFilled ? (
        <>
          <ViewTrigger
            name={`${name}.trigger`}
            onRemove={handleRemove}
            onEdit={handleEdit}
          />
          <ViewBenefit
            name={name}
            onRemove={handleRemove}
            onEdit={handleEdit}
          />
        </>
      ) : (
        <Empty name={name} onAdd={handleEdit} />
      )}

      <EditorProgressiveDiscount
        initialConfig={config}
        onSave={handleSave}
        state={editorState}
      />
    </>
  )
}
